export default "__VITE_ASSET__C5gIrZ37__"